import { render, staticRenderFns } from "./ScriptPicker.vue?vue&type=template&id=f23b21d6&scoped=true"
import script from "./ScriptPicker.vue?vue&type=script&lang=js"
export * from "./ScriptPicker.vue?vue&type=script&lang=js"
import style0 from "./ScriptPicker.vue?vue&type=style&index=0&id=f23b21d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23b21d6",
  null
  
)

export default component.exports